module.exports = __webpack_public_path__ + "img/clian5.ef63a8a3.png";